<template>
  <lock-scroll :locked="lockScroll">
    <lock-screen :locked="lockScreen" />
    <app-layout>
      <div
        class="flex flex-col items-center py-4"
        :class="{ 'cursor-not-allowed': disabled }"
      >
        <div class="w-full lg:w-4/5 px-4">
          <div class="w-full flex justify-between items-center mb-4">
            <h1 class="text-3xl font-bold text-gray-700 mb-6">Dashboard</h1>
            <div>
              <div class="flex space-x-2">
                <button
                  class="px-4 py-2 rounded border border-purple-500"
                  :class="{
                    'bg-purple-500 text-white': active === 1,
                    'bg-white text-purple-500': active !== 1,
                    'cursor-not-allowed opacity-50': disabled,
                  }"
                  :disabled="disabled"
                  @click="changeActive(1)"
                >
                  Hoy
                </button>
                <button
                  class="px-4 py-2 rounded border border-purple-500"
                  :class="{
                    'bg-purple-500 text-white': active === 2,
                    'bg-white text-purple-500': active !== 2,
                    'cursor-not-allowed opacity-50': disabled,
                  }"
                  :disabled="disabled"
                  @click="changeActive(2)"
                >
                  Semana
                </button>
                <button
                  class="px-4 py-2 rounded border border-purple-500"
                  :class="{
                    'bg-purple-500 text-white': active === 3,
                    'bg-white text-purple-500': active !== 3,
                    'cursor-not-allowed opacity-50': disabled,
                  }"
                  :disabled="disabled"
                  @click="changeActive(3)"
                >
                  Mes
                </button>
              </div>
            </div>
          </div>
          <div
            class="bg-white rounded-lg shadow p-2 pl-4 pr-4 w-full border border-gray-200 mb-3 flex flex-row items-center justify-between"
          >
            <div class="text-center py-2">
              <span class="text-xl font-bold"> Hola {{ fullname }} 👋 </span>
            </div>
            <div class="text-center flex flex-row gap-2 items-center">
              <span class="text-xl font-bold text-gray-500">
                Hoy {{ this.$moment(today).format("DD  MMMM  YYYY") }}
              </span>
              <div
                class="w-1/3flex flex-row justify-end items-center space-x-2"
                v-if="
                  $store.state.business.id &&
                  $store.state.account.canCloseBusiness
                "
              >
                <el-dropdown trigger="click" @command="close">
                  <button
                    class="px-4 py-2 rounded shadow border text-white bg-purple-500 hover:text-white border-purple-500 hover:border-purple-600 hover:bg-purple-600"
                  >
                    Cerrar
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command="CloseBusinessType.Day"
                      :disabled="IsBusinessClosedThisDay"
                      >Día</el-dropdown-item
                    >
                    <el-dropdown-item
                      class="flex items-center"
                      :command="CloseBusinessType.Week"
                      :disabled="IsBusinessClosedThisWeek || !isProMembership"
                      >Semana <pro-link v-if="!isProMembership"></pro-link
                    ></el-dropdown-item>
                    <el-dropdown-item
                      class="flex items-center"
                      :command="CloseBusinessType.Month"
                      :disabled="IsBusinessClosedThisMonth || !isProMembership"
                      >Mes <pro-link v-if="!isProMembership"></pro-link
                    ></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div
                  class="relative inline-block"
                  @mouseenter="visible = true"
                  @mouseleave="visible = false"
                >
                  <i
                    class="bx bx-info-circle text-blue-500 text-sm pl-2 pt-0.5 cursor-pointer"
                  ></i>

                  <div
                    v-if="visible"
                    class="absolute z-50 mt-2 w-80 p-4 bg-white border border-gray-200 rounded-lg shadow-lg text-sm text-gray-700 leading-relaxed"
                  >
                    <p class="mb-2 font-semibold">
                      En caso de no hacer el cierre manualmente
                    </p>
                    <p class="mb-2">
                      Samii hará el corte de manera automática (dependiendo la
                      zona horaria) y se enviará por correo:
                    </p>
                    <ul class="list-disc list-inside space-y-1">
                      <li>
                        <strong>Día:</strong> cada día a las
                        <strong>9pm</strong>
                      </li>
                      <li>
                        <strong>Semana:</strong> domingo
                        <strong>9pm</strong>
                      </li>
                      <li>
                        <strong>Mes:</strong> último día del mes
                        <strong>9pm</strong>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <account-compliance-banner
            v-if="!isFullCompliance || isRewardActivated"
          />
          <account-compliance-progress v-if="!isFullCompliance" />
          <div class="flex flex-col lg:flex-row py-2 lg:space-x-2">
            <card-button
              :disabled="disabled"
              class="w-full align-middle lg:w-1/3 mb-2"
              style="background: rgb(252, 165, 165); color: #fff; border: none"
              name="orders.index"
              :params="{ status: `${restrictedStatuses.PendingAssignment.id}` }"
            >
              <div class="flex flex-row justify-between items-center">
                <div class="flex flex-col">
                  <span class="text-md ml-2">Por Asignar</span>
                  <span class="text-3xl font-extrabold ml-2">
                    {{ counts.pendingAssignment }}
                  </span>
                </div>
                <div>
                  <i class="text-4xl bx bx-time align-bottom"></i>
                </div>
              </div>
            </card-button>
            <card-button
              :disabled="disabled"
              class="w-full align-middle lg:w-1/3 mb-2"
              style="background: rgb(110, 231, 183); color: #fff; border: none"
              name="orders.index"
              :params="{ status: `${restrictedStatuses.InProgress.id}` }"
            >
              <div class="flex flex-row justify-between items-center">
                <div class="flex flex-col">
                  <span class="text-md ml-2">En Proceso</span>
                  <span class="text-3xl font-extrabold ml-2">
                    {{ counts.inProgress }}
                  </span>
                </div>
                <div>
                  <i class="text-4xl bx bx-cog align-bottom"></i>
                </div>
              </div>
            </card-button>
            <card-button
              :disabled="disabled"
              class="w-full align-middle lg:w-1/3 mb-2"
              style="background: rgb(165, 180, 252); color: #fff; border: none"
              name="orders.index"
              :params="{ status: `${restrictedStatuses.ToBeDelivered.id}` }"
            >
              <div class="flex flex-row justify-between items-center">
                <div class="flex flex-col">
                  <span class="text-md ml-2">Por Entregar</span>
                  <span class="text-3xl font-extrabold ml-2">
                    {{ counts.toBeDelivered }}
                  </span>
                </div>
                <div>
                  <i class="text-4xl bx bx-package align-bottom"></i>
                </div>
              </div>
            </card-button>
          </div>
          <div class="flex flex-col space-y-6 mt-5">
            <content-card
              title="Órdenes con fecha límite en esta semana"
              with-options
              v-loading.fullscreen.lock="loading"
            >
              <div class="py-2">
                <div>
                  <orders-grid
                    :hasActions="!disabled"
                    :orders="orders"
                    @onStatusUpdate="updateStatus"
                    @onSorting="handleSorting"
                  />
                </div>
              </div>
            </content-card>
          </div>
          <div class="flex flex-col lg:flex-row py-2 lg:space-x-2">
            <div
              class="bg-white rounded-lg shadow p-4 flex-1 flex flex-col justify-center border-l-4 border-purple-500"
              v-if="businessInfoCloseDaily && businessInfoCloseDaily.createdAt"
            >
              <div class="text-lg font-bold text-gray-600 mb-2">
                El dia
                <span class="text-purple-600">{{
                  businessInfoCloseDaily?.createdAt
                    ? this.$moment(businessInfoCloseDaily.createdAt).format(
                        "DD [de] MMMM [de] YYYY"
                      )
                    : ""
                }}</span>
                fue cerrado
              </div>
              <div class="text-gray-600 mb-4">
                El cierre de este día se realizó a las
                <span class="text-purple-600 font-bold">
                  {{
                    businessInfoCloseDaily?.createdAt
                      ? this.$moment(businessInfoCloseDaily.createdAt).format(
                          "hh:mm A"
                        )
                      : ""
                  }}
                </span>
                y se ejecuto de manera
                <span v-if="businessInfoCloseDaily.isManual">
                  <span class="text-purple-600 font-bold">manual</span> por
                  <span class="text-purple-600 font-bold">{{
                    businessInfoCloseDaily.createdFullName
                  }}</span
                  >. </span
                ><span v-if="!businessInfoCloseDaily.isManual">
                  <span class="text-purple-600 font-bold">automatica</span>.
                </span>
              </div>
              <div class="text-gray-600 mb-4">
                <i>
                  Órdenes entregadas después del corte se verán reflejadas en
                  las métricas del
                  <span class="text-purple-600 font-bold">
                    {{
                      this.$moment(businessInfoCloseDaily.createdAt)
                        .add(1, "day")
                        .format("DD [de] MMMM [de] YYYY")
                    }}
                  </span>
                </i>
              </div>
              <button
                v-if="isOwner"
                class="lg:w-1/3 px-4 py-2 rounded bg-red-500 text-white font-bold mt-2"
                @click="removeDailyClosure"
              >
                <i class="bx bx-trash mr-2"></i>Eliminar cierre de hoy
              </button>
            </div>
          </div>

          <div class="w-full flex flex-col lg:flex-row space-y-6">
            <div
              style="height: 520px"
              class="w-full lg:w-2/4 md:w-full bg-white rounded-lg shadow p-4 border border-gray-200 mt-20"
            >
              <chart :options="chartOptions" />
            </div>
            <div class="w-full lg:w-2/4 md:w-full">
              <div class="flex flex-row justify-center items-center mb-1">
                <button
                  class="mb-4 px-4 py-2 rounded font-bold"
                  :class="{
                    'bg-purple-500 text-white': indexWidgetTab === 0,
                    'bg-white text-purple-500': indexWidgetTab !== 0,
                  }"
                  @click="indexWidgetTab = 0"
                >
                  <i class="bx bx-bell"></i> Notificaciones
                </button>
                <button
                  v-if="
                    $store.state.account.accountType ===
                      AccountTypeEnum.Owner ||
                    $store.state.account.canCloseBusiness
                  "
                  class="mb-4 px-4 py-2 rounded font-bold"
                  :class="{
                    'bg-purple-500 text-white': indexWidgetTab === 1,
                    '': indexWidgetTab !== 1,
                  }"
                  @click="load(true)"
                >
                  <i class="bx bx-dollar"></i> Finanzas
                </button>
              </div>
              <notifications v-if="indexWidgetTab === 0" />
              <div
                class="w-full bg-white rounded-lg shadow p-4 border border-gray-200 ml-5"
                style="align-self: center; height: 520px; margin-top: -1px"
                v-if="
                  ($store.state.account.accountType === AccountTypeEnum.Owner ||
                    $store.state.account.canCloseBusiness) &&
                  indexWidgetTab === 1
                "
              >
                <div
                  class="w-full flex flex-row justify-between items-center mb-5"
                >
                  <div class="w-2/3">
                    <h1 class="text-xl font-bold text-gray-700">
                      Métricas Financieras
                    </h1>

                    <h1 class="text-md text-gray-700 mb-4">
                      <span v-if="active === 1">
                        Hoy:
                        {{ $moment(filters.dueDateStart).format("DD/MM/YYYY") }}
                      </span>
                      <span v-else-if="active === 2">
                        Esta semana:
                        {{ $moment(filters.dueDateStart).format("DD/MM/YYYY") }}
                        -
                        {{ $moment(filters.dueDateEnd).format("DD/MM/YYYY") }}
                      </span>
                      <span v-else-if="active === 3">
                        Este mes:
                        {{ $moment(filters.dueDateStart).format("DD/MM/YYYY") }}
                        -
                        {{ $moment(filters.dueDateEnd).format("DD/MM/YYYY") }}
                      </span>
                    </h1>
                  </div>
                </div>
                <div class="w-full flex flex-col" v-if="loadFinancialMetrics">
                  <div class="w-full flex flex-col justify-center items-center">
                    <i
                      class="bx bx-loader-alt text-4xl text-gray-500 animate-spin"
                    ></i>
                    <span class="text-lg text-gray-500 ml-2"
                      >Cargando métricas financieras...</span
                    >
                  </div>
                </div>

                <div class="w-full flex flex-col" v-if="!loadFinancialMetrics">
                  <div class="w-full flex flex-row">
                    <div class="w-2/3"></div>
                    <div class="w-1/3">
                      <div
                        class="flex flex-col bg-white rounded-lg shadow p-3 border border-gray-200 mb-4"
                      >
                        <div
                          class="flex flex-row justify-between items-center mb-2"
                        >
                          <div class="flex flex-col">
                            <i
                              class="bx bx-package text-purple-600 text-2xl"
                            ></i>
                            <h1 class="text-sm text-gray-700 mb-1">
                              Finalizados
                              <el-tooltip
                                content="Órdenes de reparación completadas y entregadas"
                                placement="top"
                              >
                                <i
                                  class="bx bx-info-circle text-blue-500 text-sm pl-2 pt-0.5 cursor-pointer"
                                ></i>
                              </el-tooltip>
                            </h1>
                            <h2 class="text-xl font-extrabold">
                              {{ counts.finalized }}
                            </h2>
                          </div>
                          <div class="flex flex-row"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="w-full flex flex-row gap-2">
                    <div class="w-1/3">
                      <div
                        class="flex flex-col bg-white rounded-lg shadow p-3 border border-gray-200 mb-4"
                      >
                        <div
                          class="flex flex-row justify-between items-center mb-2"
                        >
                          <div class="flex flex-col">
                            <i
                              class="bx bx-dollar-circle text-purple-500 text-2xl"
                            ></i>
                            <h1 class="text-sm text-gray-700 mb-1">
                              Venta Total
                              <el-tooltip
                                content="Incluye ventas + anticipos + impuestos cobrados"
                                placement="top"
                              >
                                <i
                                  class="bx bx-info-circle text-blue-500 text-sm pl-2 pt-0.5 cursor-pointer"
                                ></i>
                              </el-tooltip>
                            </h1>
                            <h2 class="text-lg font-extrabold">
                              {{ moneyFormat(totalSale) }}
                            </h2>
                          </div>
                          <div class="flex flex-row"></div>
                        </div>
                      </div>
                    </div>
                    <div class="w-1/3">
                      <div
                        class="flex flex-col bg-white rounded-lg shadow p-3 border border-gray-200 mb-4"
                      >
                        <div
                          class="flex flex-row justify-between items-center mb-2"
                        >
                          <div class="flex flex-col">
                            <i
                              class="bx bx-dollar-circle text-purple-500 text-2xl"
                            ></i>
                            <h1 class="text-sm text-gray-700 mb-1">
                              Costos
                              <el-tooltip
                                content="Costo directo de repuestos y materiales utilizados en servicios y/o productos"
                                placement="top"
                              >
                                <i
                                  class="bx bx-info-circle text-blue-500 text-sm pl-2 pt-0.5 cursor-pointer"
                                ></i>
                              </el-tooltip>
                            </h1>
                            <h2 class="text-lg font-extrabold">
                              {{ moneyFormat(totalCosts) }}
                            </h2>
                          </div>
                          <div class="flex flex-row"></div>
                        </div>
                      </div>
                    </div>
                    <div class="w-1/3">
                      <div
                        class="flex flex-col bg-white rounded-lg shadow p-3 border border-gray-200 mb-4"
                      >
                        <div
                          class="flex flex-row justify-between items-center mb-2"
                        >
                          <div class="flex flex-col">
                            <i
                              class="bx bx-dollar-circle text-purple-500 text-2xl"
                            ></i>
                            <h1 class="text-sm text-gray-700 mb-1">
                              Margen Bruto
                              <el-tooltip
                                content="Venta Total menos Costos directos de materiales"
                                placement="top"
                              >
                                <i
                                  class="bx bx-info-circle text-blue-500 text-sm pl-2 pt-0.5 cursor-pointer"
                                ></i>
                              </el-tooltip>
                            </h1>
                            <h2 class="text-lg font-extrabold">
                              {{ moneyFormat(partialSale) }}
                            </h2>
                          </div>
                          <div class="flex flex-row"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="w-full flex flex-row gap-2"
                    v-if="isProMembership"
                  >
                    <div class="w-1/3">
                      <div
                        class="flex flex-col bg-white rounded-lg shadow p-3 pl-2 border border-gray-200 mb-4"
                      >
                        <div
                          class="flex flex-row justify-between items-center mb-2"
                        >
                          <div class="flex flex-col">
                            <i
                              class="bx bx-dollar-circle text-purple-500 text-2xl"
                            ></i>
                            <h1 class="text-sm text-gray-700 mb-1">
                              Gastos General
                              <el-tooltip
                                content="Gastos fijos + gastos variables + gastos inventario"
                                placement="top"
                              >
                                <i
                                  class="bx bx-info-circle text-blue-500 text-sm pl-2 pt-0.5 cursor-pointer"
                                ></i>
                              </el-tooltip>
                            </h1>
                            <h2 class="text-lg font-extrabold">
                              {{ moneyFormat(totalExpense) }}
                            </h2>
                          </div>
                          <div class="flex flex-row"></div>
                        </div>
                      </div>
                    </div>
                    <div class="w-1/3">
                      <div
                        class="flex flex-col bg-white rounded-lg shadow p-3 border border-gray-200 mb-4"
                      >
                        <div
                          class="flex flex-row justify-between items-center mb-2"
                        >
                          <div class="flex flex-col">
                            <i
                              class="bx bx-dollar-circle text-purple-500 text-2xl"
                            ></i>
                            <h1 class="text-sm text-gray-700 mb-1">
                              Impuestos
                              <el-tooltip
                                content="Impuestos totales"
                                placement="top"
                              >
                                <i
                                  class="bx bx-info-circle text-blue-500 text-sm pl-2 pt-0.5 cursor-pointer"
                                ></i>
                              </el-tooltip>
                            </h1>
                            <h2 class="text-lg font-extrabold">
                              {{ moneyFormat(totalTax) }}
                            </h2>
                          </div>
                          <div class="flex flex-row"></div>
                        </div>
                      </div>
                    </div>
                    <div class="w-1/3">
                      <div
                        class="flex flex-col bg-white rounded-lg shadow p-3 border border-gray-200 mb-4"
                      >
                        <div
                          class="flex flex-row justify-between items-center mb-2"
                        >
                          <div class="flex flex-col">
                            <i
                              class="bx bx-dollar-circle text-purple-500 text-2xl"
                            ></i>
                            <h1 class="text-sm text-gray-700 mb-1">
                              Utilidad
                              <el-tooltip
                                content="Ganancia neta: Margen Bruto menos Gastos e Impuestos"
                                placement="top"
                              >
                                <i
                                  class="bx bx-info-circle text-blue-500 text-sm pl-2 pt-0.5 cursor-pointer"
                                ></i>
                              </el-tooltip>
                            </h1>
                            <h2 class="text-lg font-extrabold">
                              {{ moneyFormat(totalUtility) }}
                            </h2>
                          </div>
                          <div class="flex flex-row"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        :visible.sync="showQuickStartDialog"
        width="75%"
        @close="start"
      >
        <div class="text-center">
          <div>
            <span class="text-5xl text-gray-500 font-bold"
              >Bienvenido a Samii</span
            >
          </div>
          <div>
            <img
              src="@/assets/img/welcome-samii.png"
              width="320px"
              class="m-auto"
            />
          </div>
          <div>
            <span class="text-4xl text-gray-400">
              El primer software para técnicos hecho por un técnico.
            </span>
          </div>
          <div class="w-full">
            <div class="text-right">
              <el-button class="el-button--primary" @click="start"
                >Crear mi Primer Orden</el-button
              >
            </div>
          </div>
        </div>
      </el-dialog>
      <onboarding ref="onboarding" @on:completed="handleOnboardingCompleted" />
      <security ref="security" @on:completed="handleSecuritySetupCompleted" />
    </app-layout>
  </lock-scroll>
</template>

<script>
import CardButton from "@/components/molecules/CardButton";
import { DateFormats, CloseBusinessType, AccountTypeEnum } from "@/constants";
import HomeService from "@/services/HomeService";
import OrderService from "@/services/OrderService";
import BusinessService from "@/services/BusinessService";
import OrdersGrid from "@/views/app/orders/grid/Index.vue";
import { Chart } from "highcharts-vue";
import numbers from "@/utils/numbers";
import error from "@/mixins/error";
import { QUICK_START_STORE } from "@/store/modules/quick-start/mutation-types";
import OrderPaymentDialogService, {
  command as OrderPaymentDialogCommand,
  commands as OrderPaymentDialogCommands,
} from "@/components/dialogs/OrderPayment/service";
import { LOCAL_STORAGE_SAMII_KEYS, setItem } from "@/utils/storage";
import { getRestrictedStatuses } from "@/helpers/order-status.helper";
import TheHeaderAppServices from "@/components/organisms/services/TheHeaderAppServices";
import { MessageBox } from "element-ui";
import Swal from "sweetalert2";
import AccountService from "@/services/AccountService";
import { updateCompliance } from "@/utils/compliance";
import Notifications from "@/components/organisms/Notifications";

export default {
  name: "HomeIndex",
  mixins: [error],
  components: {
    OrdersGrid,
    ProLink: () => import("@/components/atoms/SaProLink.vue"),
    AppLayout: () => import("@/components/layouts/AppLayout"),
    ContentCard: () => import("@/components/molecules/ContentCard"),
    CardButton,
    Chart,
    AccountComplianceProgress: () =>
      import("@/components/organisms/AccountCompliance/Progress"),
    AccountComplianceBanner: () =>
      import("@/components/organisms/AccountCompliance/Banner"),
    Notifications,
  },
  data() {
    return {
      loadFinancialMetrics: false,
      visible: false,
      AccountTypeEnum,
      CloseBusinessType,
      loading: false,
      IsBusinessClosedThisDay: false,
      IsBusinessClosedThisWeek: false,
      IsBusinessClosedThisMonth: false,
      businessInfoCloseDaily: null,
      active: 1,
      orders: [],
      filters: {
        dueDateEnd: this.$moment(new Date()).format("MM/DD/YYYY"),
        dueDateStart: this.$moment(new Date()).format("MM/DD/YYYY"),
      },
      totalCosts: 0,
      totalProfit: 0,
      totalSale: 0,
      partialSale: 0,
      totalExpense: 0,
      totalTax: 0,
      totalUtility: 0,
      counts: {
        finalized: 0,
        inProgress: 0,
        pendingAssignment: 0,
        toBeDelivered: 0,
      },
      chartOptions: {
        colors: ["#FCA5A5", "#6EE7B7", "#A5B4FC"],
        credits: {
          enabled: false,
        },
        chart: {
          type: "pie",
          options3d: {
            enabled: false,
            alpha: 45,
          },
          margin: [40, 0, 0, 0],
          spacingTop: 10,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0,
        },
        title: {
          text: "Estado de Órdenes",
          align: "left",
        },
        plotOptions: {
          pie: {
            innerSize: 100,
            depth: 10,
          },
        },
        series: [
          {
            name: "Estado",
            data: [
              ["Por Asignar", 0],
              ["En Proceso", 0],
              ["Por Entregar", 0],
            ],
          },
        ],
      },
      lockScroll: false,
      lockScreen: false,
      showQuickStartDialog: false,
      subscription: null,
      headerAppSubscription: null,
      routeToRedirectAfterOnboarding: null,
      indexWidgetTab: 0,
    };
  },
  computed: {
    isRewardActivated() {
      return this.$store.state.account.accountCompliance?.rewardActivatedAt;
    },
    isProMembership() {
      return (
        this.$store.state.account.membershipType === 2 ||
        this.$store.state.account.membershipType === 3
      );
    },
    isOwner() {
      return this.$store.state.account.accountType === AccountTypeEnum.Owner;
    },
    today() {
      const format =
        this.$store.state.business.dateFormat?.toUpperCase() ?? "MM/DD/YYYY";
      return this.$moment(new Date()).format(format);
    },
    fullname() {
      return this.$store.state.account.fullname;
    },
    disabled() {
      return this.$store.state.account.membershipLimitReached;
    },
    restrictedStatuses() {
      const { PendingAssignment, InProgress, ToBeDelivered, Finalized } =
        getRestrictedStatuses(this.$store.state.catalogs.order.statuses);

      return {
        PendingAssignment,
        InProgress,
        ToBeDelivered,
        Finalized,
      };
    },
    utility() {
      return this.partialSale - this.totalExpense;
    },
    isFullCompliance() {
      const c = this.$store.state.account.accountCompliance;
      if (!c) return true;
      return !!(
        c.practiceOrderCompletedAt &&
        c.businessConfiguredAt &&
        c.firstRealOrderCompletedAt &&
        c.firstProductAddedAt &&
        c.reportsVisitedAt &&
        c.rewardActivatedAt
      );
    },
  },
  created() {
    this.indexWidgetTab = 0;
    this.subscription = OrderPaymentDialogCommand.subscribe(
      this.handleOrderPaymentDialogCommands
    );
    this.headerAppSubscription = TheHeaderAppServices.command.subscribe(
      this.handleHeaderAppCommands
    );
  },
  destroyed() {
    this.subscription.unsubscribe();
    this.headerAppSubscription.unsubscribe();
  },
  mounted() {
    const { accountCompliance } = this.$store.state.account;
    this.indexWidgetTab = 0;
    if (!accountCompliance) {
      this.load();
      return;
    }

    this.waitAndShowCompliance();
  },
  methods: {
    waitAndShowCompliance() {
      if (!this.$refs.onboarding || !this.$refs.security) {
        setTimeout(() => this.waitAndShowCompliance(), 50);
        return;
      }

      const { accountCompliance } = this.$store.state.account;

      if (!accountCompliance.onboardingCompletedAt) {
        this.$refs.onboarding.show();
        return;
      }

      if (!accountCompliance.securitySetupCompletedAt) {
        this.$refs.security.show();
        return;
      }

      this.load();
    },
    handleOnboardingCompleted(route) {
      this.save("onboardingCompletedAt");
      this.$router.push(route);
    },
    handleSecuritySetupCompleted() {
      this.save("securitySetupCompletedAt");
    },
    async save(complianceType) {
      const accountId = this.$store.state.account.id;
      await AccountService.updateCompliance(accountId, {
        ComplianceType: complianceType,
      });
      await updateCompliance(this, complianceType);
    },
    async showDateFormatSelector() {
      const { value: result } = await this.$swal.fire({
        html: `
          <strong>Configuración de Formato de Fechas</strong>
          <br>
          Ahora puedes configurar el formato de la fecha para tu negocio
        `,
        input: "select",
        inputOptions: DateFormats,
        showCancelButton: false,
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async (dateFormat) => {
          try {
            await BusinessService.saveDateFormat({
              dateFormat: DateFormats[dateFormat],
            });
            return { success: true, value: dateFormat };
          } catch (error) {
            return {
              success: false,
              message: "No se pudo actualizar el formato de fecha",
            };
          }
        },
      });
      if (result.success) {
        this.$toastr.s(
          `Se configuró con exito: <br> Formato <strong>${
            DateFormats[result.value]
          }</strong>`
        );
        setItem(LOCAL_STORAGE_SAMII_KEYS.DATE_FORMAT_STATUS, "done");
      } else {
        this.$toastr.e(result.message);
      }
    },
    async updateFilters() {
      const init = new Date();
      const last = new Date();
      if (this.active === 1) {
        this.filters.dueDateStart = this.$moment(init).format("MM/DD/YYYY");
        this.filters.dueDateEnd = this.$moment(last).format("MM/DD/YYYY");
      }
      if (this.active === 2) {
        const dayOfWeek = init.getDay();
        const diffToMonday = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek;
        const firstDayOfWeek = new Date(init);
        firstDayOfWeek.setDate(init.getDate() + diffToMonday);
        const lastDayOfWeek = new Date(firstDayOfWeek);
        lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
        this.filters.dueDateStart =
          this.$moment(firstDayOfWeek).format("MM/DD/YYYY");
        this.filters.dueDateEnd =
          this.$moment(lastDayOfWeek).format("MM/DD/YYYY");
      }
      if (this.active === 3) {
        const month = init.getMonth();
        const year = init.getFullYear();
        this.filters.dueDateStart = this.$moment(
          new Date(year, month, 1)
        ).format("MM/DD/YYYY");
        this.filters.dueDateEnd = this.$moment(
          new Date(year, month + 1, 0)
        ).format("MM/DD/YYYY");
      }
    },
    async changeActive(index) {
      if (this.disabled) return;
      this.active = index;
      await this.updateFilters();
      await this.load();
    },
    async removeDailyClosure() {
      Swal.fire({
        title: "¿Estás seguro de eliminar el cierre diario?",
        html: "Esta acción eliminará el cierre diario y todas las métricas asociadas. <br><br><b>Esta acción no podrá revertirse.</b><br><br>¿Deseas continuar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar cierre",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const result = await HomeService.PostRevertClosedDaily({
            businessInfoId: this.$store.state.business.id,
          });
          if (result) {
            this.$toastr.s("Se eliminó el cierre diario con éxito");
            await this.load();
          } else {
            this.$toastr.e("No se pudo eliminar el cierre diario");
          }
        }
      });
    },
    async load(showFinancials = false) {
      try {
        if (!showFinancials) {
          this.indexWidgetTab = 0;
          this.loading = true;
        } else {
          this.loadFinancialMetrics = true;
          this.indexWidgetTab = 1;
        }
        const dashboard = await HomeService.Dashboard({
          ...this.filters,
          businessInfoId: this.$store.state.business.id,
          showFinancials: showFinancials,
        });
        this.IsBusinessClosedThisDay = dashboard.isBusinessClosedThisDay;
        this.IsBusinessClosedThisWeek = dashboard.isBusinessClosedThisWeek;
        this.IsBusinessClosedThisMonth = dashboard.isBusinessClosedThisMonth;
        this.businessInfoCloseDaily = dashboard.businessInfoCloseDaily;
        this.orders = dashboard.orders.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        this.partialSale = dashboard.partialSales;
        this.totalSale = dashboard.totalSales;
        this.totalExpense = dashboard.totalExpenses;
        this.totalTax = dashboard.totalTaxes;
        this.totalUtility = dashboard.totalUtility;
        this.totalCosts = dashboard.totalCosts;
        this.totalProfit = dashboard.totalProfit;
        this.counts = dashboard.totalsAmount;
        this.chartOptions.series = [
          {
            name: "Estado",
            data: [
              ["Por Asignar", this.counts.pendingAssignment],
              ["En Proceso", this.counts.inProgress],
              ["Por Entregar", this.counts.toBeDelivered],
            ],
          },
        ];

        const business = await this.$store.state.business;
        if (business.id && !business.timezone) {
          this.$swal
            .fire({
              title: "Falta Información en tu Perfil",
              icon: "info",
              text: "Ahora puedes indicar la zona horaria en la que te encuentras. Puedes modificarlo desde tu perfil.",
              confirmButtonText: '<i class="fa fa-thumbs-up"></i> OK',
            })
            .then(() => {
              this.$router.push({
                name: "administration.business",
              });
            });
        }
        this.loading = false;
        this.loadFinancialMetrics = false;
        if (showFinancials) {
          this.indexWidgetTab = 1;
        }
      } catch (e) {
        this.$toastr.e(this.getErrorMessage(e));
        this.loading = false;
        this.loadFinancialMetrics = false;
      }
    },
    async updateOrderStatus({ orderId, status, paymentMethod = undefined }) {
      await OrderService.updateStatus({ id: orderId, status, paymentMethod });
      this.$toastr.s("Se actualizo con exito");
      await this.load();
    },
    updateStatus({ orderId, status, nextDay = false }) {
      this.loading = true;
      try {
        const { Finalized } = this.restrictedStatuses;
        if (status === Finalized.id) {
          OrderPaymentDialogService.show({ orderId, status, nextDay });
        } else {
          this.updateOrderStatus({ orderId, status, nextDay });
        }
      } catch (e) {
        this.$toastr.e(this.getErrorMessage(e));
      } finally {
        this.loading = false;
      }
    },
    moneyFormat(value) {
      const { currencySymbol } = this.$store.state.account;
      return numbers.moneyFormat(value, currencySymbol);
    },
    handleSorting(sorting) {
      const keys = Object.keys(sorting);
      const direction = sorting[keys];
      this.orders = this.orders.sort((a, b) => {
        if (direction === "desc")
          return new Date(b.createdAt) - new Date(a.createdAt);
        return new Date(a.createdAt) - new Date(b.createdAt);
      });
    },
    start() {
      this.showQuickStartDialog = false;
      this.$store.dispatch(QUICK_START_STORE, { step: 1 });
    },
    close(command) {
      if (!this.$store.state.account.canCloseBusiness) {
        this.$toastr.e("No cuentas con el permiso para cerrar el dia");
        return;
      }

      if (!Object.values(CloseBusinessType).includes(command)) {
        console.warn("Comando no valido:", command);
        return;
      }
      switch (command) {
        case CloseBusinessType.Day:
          this.closeDay();
          break;
        case CloseBusinessType.Week:
          this.closeWeek();
          break;
        case CloseBusinessType.Month:
          this.closeMonth();
          break;
        default:
          console.warn("Commando no reconocido:", command);
      }
    },
    removePreviewButton() {
      const existingPreviewBtn = document.querySelector(
        ".el-button.preview-btn"
      );
      if (existingPreviewBtn) {
        existingPreviewBtn.remove();
      }
    },
    closeDay() {
      this.removePreviewButton();

      MessageBox({
        title: "Confirmar cierre",
        message: `<div id="close-day-confirm">¿Seguro que deseas cerrar <b>día</b> en sucursal <b>${this.$store.state.business.name}</b>?</div>`,
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        showClose: true,
        confirmButtonText: "Confirmar cierre",
        cancelButtonText: "Cancelar",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        callback: (action) => {
          if (action === "confirm") {
            Swal.fire({
              title: "¿Estás seguro de cerrar el día?",
              html: "Al cerrar el día, el dashboard se verá en <b>0</b> hasta el siguiente día.<br><br><b>Esta acción no podrá revertirse.</b><br><br>¿Deseas continuar?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Sí, cerrar día",
              cancelButtonText: "Cancelar",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push({
                  name: "close.business",
                  params: { businessInfoId: this.$store.state.business.id },
                });
              }
            });
          }
        },
      });

      this.$nextTick(() => {
        const isDailyConfirm = document.querySelector("#close-day-confirm");
        const dialog = document.querySelector(".el-message-box__btns");
        const existingPreviewBtn = document.querySelector(
          ".el-button.preview-btn"
        );

        if (isDailyConfirm && dialog && !existingPreviewBtn) {
          const previewBtn = document.createElement("button");
          previewBtn.innerText = "Vista previa";
          previewBtn.className =
            "el-button el-button--success el-button--small preview-btn";
          previewBtn.onclick = () => {
            this.$router.push({
              name: "close.business",
              params: {
                businessInfoId: this.$store.state.business.id,
                isPreview: true,
              },
            });

            const closeBtn = document.querySelector(
              ".el-message-box__headerbtn"
            );
            if (closeBtn) closeBtn.click();
          };
          dialog.insertBefore(previewBtn, dialog.firstChild);
        }
      });
    },
    closeWeek() {
      this.removePreviewButton();

      this.$confirm(
        `¿Seguro que deseas cerrar <b>semana</b> en sucursal <br/><b>${this.$store.state.business.name}</b>?`,
        {
          type: "warning",
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          dangerouslyUseHTMLString: true,
        }
      ).then(async () => {
        BusinessService.closure({
          businessId: this.$store.state.account.businessId,
          accountId: this.$store.state.account.id,
          businessInfoId: this.$store.state.business.id,
          closureType: CloseBusinessType.Week,
        });
        this.$toastr.s(
          "El reporte semanal se enviara por correo en cuanto este listo"
        );
      });
    },
    closeMonth() {
      this.removePreviewButton();

      this.$confirm(
        `¿Seguro que deseas cerrar <b>mes</b> en sucursal <br/><b>${this.$store.state.business.name}</b>?`,
        {
          type: "warning",
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          dangerouslyUseHTMLString: true,
        }
      ).then(async () => {
        BusinessService.closure({
          businessId: this.$store.state.account.businessId,
          accountId: this.$store.state.account.id,
          businessInfoId: this.$store.state.business.id,
          closureType: CloseBusinessType.Month,
        });
        this.$toastr.s(
          "El reporte mensual se enviara por correo en cuanto este listo"
        );
      });
    },
    handleOrderPaymentDialogCommands({ type, payload }) {
      switch (type) {
        case OrderPaymentDialogCommands.Select:
          this.updateOrderStatus({
            orderId: payload.orderId,
            status: payload.status,
            paymentMethod: payload.paymentMethod,
          });
          break;
        default:
      }
    },
    handleHeaderAppCommands({ type }) {
      switch (type) {
        case TheHeaderAppServices.commands.onBusinessChange:
          this.load();
          break;
        default:
      }
    },
  },
};
</script>
